<script>
	export let open = false;
	let skipActive = false;

	function esc(e) {
		if (e.key === "Escape") {
			open = false;
		}
		return;
	}

	const links = [
		["./index", "Home"],
		["#", "About"],
		["./written", "Written"],
		["mailto:mustafa.gulsun@hotmail.com", "@Contact"],
	];
</script>

<svelte:window on:keydown={esc} />

<nav class="container main-nav">
	<a
		href="#main"
		class:sr-only={!skipActive}
		on:focus={() => (skipActive = true)}
		on:blur={() => (skipActive = false)}
		class="skip-nav sr-only"
	>
		Skip Nav
	</a>
	{#each links as [path, name]}
		<a href={path}>{name}</a>
	{/each}
</nav>

<style>
	.main-nav {
		padding: 2rem 0;
	}

	.main-nav a {
		padding: 5px;
	}
</style>
